import FormatCurrency from 'components/Common/FormatCurrency'
import SolidFireIcon from 'components/Luxkit/Icons/solid/SolidFireIcon'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Caption from 'components/Luxkit/Typography/Caption'
import Group from 'components/utils/Group'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { EmptyArray } from 'lib/array/arrayUtils'
import { displayPricingAs, getCalendarDisplayTotalPrice } from 'lib/hotels/bedbankUtils'
import { getOptimizelyExperimentVariation } from 'lib/optimizely/optimizelyUtils'
import { OptimizelyExperiments } from 'constants/optimizely'
import { pluralizeToString } from 'lib/string/pluralize'
import React from 'react'

interface Props {
  price?: number;
  propertyFees?: number;
  flightPrice?: number;
  duration: number;
  adultsNumber: number;
  withFlights?: boolean;
  displayPricingAsPerPerson: boolean;
  rooms: Array<App.RoomOccupants>;
  isPerNightPricingTestEnabled: boolean;
}

function CalendarPriceBlurb(props: Props) {
  const { isPerNightPricingTestEnabled, price, propertyFees, flightPrice, duration, adultsNumber, withFlights, displayPricingAsPerPerson, rooms = EmptyArray } = props

  const hotelPrice = price ?? 0
  const hotelPropertyFees = propertyFees ?? 0

  const {
    total,
    saleUnit,
  } = getCalendarDisplayTotalPrice({
    price: hotelPrice + hotelPropertyFees,
    adultsNumber,
    nights: duration,
    roomsNumber: rooms.length,
    withFlights: !!withFlights,
    flightPrice: flightPrice ?? 0,
    displayPricingPer: displayPricingAs(displayPricingAsPerPerson, isPerNightPricingTestEnabled),
  })

  return <Group
    direction="vertical"
    gap={4}
    tabletDirection="horizontal"
    tabletHorizontalAlign="space-between"
  >
    <div>
      <BodyText variant="medium" colour="neutral-two">
        {rooms.length > 1 && `${pluralizeToString('room', rooms.length)}, `}
        {pluralizeToString('night', duration)}{withFlights && flightPrice ? ' + flights' : undefined} from{' '}
        <BodyText as="span" variant="medium" colour="neutral-one" weight="bold">
          <FormatCurrency value={total} />
          {displayPricingAsPerPerson && <Caption variant="medium" as="span">{saleUnit}</Caption>}
        </BodyText> {!displayPricingAsPerPerson && <>{saleUnit}{withFlights && !flightPrice ? ' + flights' : undefined}.</>}
      </BodyText>
      <BodyText variant="medium" colour="neutral-one">
        * Price is indicative. Select your dates to view best available rates
      </BodyText>
    </div>
    <BodyTextBlock variant="medium" startIcon={<SolidFireIcon colour="urgency" />}>
      Limited Time Special
    </BodyTextBlock>
  </Group>
}

export default withOfferPageAndReduxState((state, appState) => ({
  duration: state.duration,
  withFlights: state.flights,
  rooms: state.rooms,
  isPerNightPricingTestEnabled: !!getOptimizelyExperimentVariation(appState, OptimizelyExperiments.pricePerNight),
}))(CalendarPriceBlurb)
